import { useMemo } from 'react';
import { makeBEM, makeRootClassName } from '../../../utils';
export var useTextInputClassNames = function useTextInputClassNames(classPrefix, className, disabled, large, error, isLabelInside, outlined) {
  return useMemo(function () {
    var rootClassNames = makeRootClassName(classPrefix, className);
    var rootStateClassNames = [];

    if (disabled) {
      rootStateClassNames.push(makeBEM(classPrefix, 'Root', 'disabled'));
    }

    if (outlined) {
      rootStateClassNames.push(makeBEM(classPrefix, 'Root', 'focus'));
    }

    if (large) {
      rootStateClassNames.push(makeBEM(classPrefix, 'Root', 'large'));
    }

    if (error) {
      rootStateClassNames.push(makeBEM(classPrefix, 'Root', 'error'));
    }

    var labelClassName = makeBEM(classPrefix, 'Label');

    if (isLabelInside) {
      labelClassName = "".concat(labelClassName, " ").concat(makeBEM(classPrefix, 'Label', 'inside'));
    }

    return {
      Root: "".concat(rootClassNames, " ").concat(rootStateClassNames.join(' ')).trim(),
      InnerContainer: makeBEM(classPrefix, 'InnerContainer'),
      Input: makeBEM(classPrefix, 'Input'),
      InputTag: makeBEM(classPrefix, 'InputTag'),
      Label: labelClassName,
      LabelBackground: makeBEM(classPrefix, 'LabelBackground')
    };
  }, [classPrefix, className, disabled, large, error, isLabelInside]);
};